<div class="review-results-container" [class.hidden]="!isActive">
    <div class="ui basic segment">
        <ng-container *ngIf="performanceReviewImprovements">
            <div class="flex justify-space-between align-items-center">
                <a (click)="exit()" class="back-button">
                    <mat-icon svgIcon="chevronLeft" [matTooltip]="'back' | translate"></mat-icon>
                    {{ 'back' | translate }}
                </a>

                <div class="buttons-container">
                    <ui-button type="outline" (click)="print()">{{ 'print' | translate }}</ui-button>
                    <ui-button *ngIf="canExportResults" type="outline" (click)="onExport('csv')">{{
                        'export-as-csv' | translate
                    }}</ui-button>
                </div>
            </div>
        </ng-container>

        <div class="toolkit">
            <ng-container *ngIf="!performanceReviewImprovements">
                <a (click)="print()" class="ui fluid no-arrow right floated blue icon button">
                    <i class="print icon"></i>
                    {{ 'print' | translate }}
                </a>

                <ui-button data-cy="back-button" (click)="exit()" type="ghost">
                    <mat-icon svgIcon="chevronLeft" />
                    {{ 'back' | translate }}
                </ui-button>
            </ng-container>

            <div class="profile">
                <app-avatar [employee]="review.subject" size="profile"></app-avatar>
                <h3 class="header">{{ review.subject.firstName }} {{ review.subject.lastName }}</h3>
            </div>

            <mat-divider class="margin-top-4 margin-bottom-3"></mat-divider>

            <div class="profile-table">
                <div (click)="changeTab('fields')" [class.active]="tab === 'fields'">
                    <span class="label">{{ 'performance.show.reviewResultsLabel' | translate }}</span>
                </div>
                <div (click)="changeTab('goals')" [class.active]="tab === 'goals'">
                    <span class="label">{{ 'performance.show.goalsCompletedLabel' | translate }}</span>
                    <div class="badge-container">
                        <ui-badge [type]="getGoalsBadgeType()">
                            {{
                                'performance.show.goalsPill'
                                    | translate
                                        : {
                                              goalsComplete: (goals | filter: 'isComplete' : true)?.length,
                                              goalsLength: goals.length,
                                          }
                            }}
                        </ui-badge>
                    </div>
                </div>
                <div (click)="changeTab('feedback-received')" [class.active]="tab === 'feedback-received'">
                    <span class="label">{{ 'performance.show.feedbackReceivedLabel' | translate }}</span>
                    <div class="badge-container">
                        <ui-badge [type]="getFeedbackBadgeType(feedbackReceived.length)">
                            {{ feedbackReceived.length }}
                        </ui-badge>
                    </div>
                </div>
                <div (click)="changeTab('feedback-given')" [class.active]="tab === 'feedback-given'">
                    <span class="label">{{ 'performance.show.feedbackGivenLabel' | translate }}</span>
                    <div class="badge-container">
                        <ui-badge [type]="getFeedbackBadgeType(feedbackGiven.length)">
                            {{ feedbackGiven.length }}
                        </ui-badge>
                    </div>
                </div>
            </div>
        </div>

        <form class="form fields printable">
            <span class="back" *ngIf="tab !== 'fields'" (click)="changeTab('fields')">
                <mat-icon svgIcon="chevronLeft" [matTooltip]="'back' | translate"></mat-icon>
                {{ 'back' | translate }}
            </span>
            <h2 class="printable-header">{{ review.subject.firstName }} {{ review.subject.lastName }}</h2>
            <h2 class="header">{{ review.title }}</h2>
            <span>{{ review.description }}</span>

            <mat-divider class="margin-top-3"></mat-divider>

            <div class="period-header">
                {{
                    'performance.show.reviewPeriodDescription'
                        | translate
                            : {
                                  reviewStartDate: review.periodStart | appDate: 'mediumDate',
                                  reviewEndDate: review.periodEnd | appDate: 'mediumDate',
                              }
                }}
            </div>

            <div class="clear"></div>

            <ng-template [ngIf]="tab === 'fields'">
                <div
                    *ngFor="let row of answeredQuestionsCollection; let index = index"
                    [attr.arr-index]="index"
                    class="field toolkit-item ui borderless segment"
                >
                    <div class="card-label font-medium">
                        {{ 'performance.show.questionCardTitle' | translate: { index: index + 1 } }}
                    </div>

                    <div *ngFor="let field of row; let index = index" [attr.arr-index]="index" class="margin-top-2">
                        <label
                            class="question-label"
                            [innerHTML]="field.question?.question | nl2br | sanitizeHtml"
                        ></label>

                        <ng-template [ngIf]="field.question?.type === 'freeform'">
                            <ui-card class="ui borderless segment user-info-card freeform-container">
                                <div class="flex align-items-center">
                                    <app-avatar
                                        *ngIf="field.employee"
                                        [employee]="field.employee"
                                        size="icon"
                                    ></app-avatar>
                                    <span class="employeeName"
                                        >{{ field.employee.firstName }} {{ field.employee.lastName }}</span
                                    >
                                </div>
                                <div
                                    *ngIf="field?.answer"
                                    class="freeform-text"
                                    [innerHtml]="field?.answer | sanitizeHtml"
                                ></div>
                            </ui-card>
                        </ng-template>

                        <ng-template [ngIf]="field.question?.type === 'multiple'">
                            <ui-card class="ui borderless segment user-info-card multiple-container">
                                <div class="flex align-items-center">
                                    <app-avatar
                                        *ngIf="field.employee"
                                        [employee]="field.employee"
                                        size="icon"
                                    ></app-avatar>
                                    <span class="employeeName"
                                        >{{ field.employee.firstName }} {{ field.employee.lastName }}</span
                                    >
                                </div>
                                <div *ngIf="field.answer !== null" class="flex margin-top-2">
                                    <mat-icon svgIcon="checkFilledCircle"></mat-icon>
                                    <label>{{ field.question.choices![field.answer] }}</label>
                                </div>
                            </ui-card>
                        </ng-template>

                        <ng-template [ngIf]="field.question?.type === 'rating'">
                            <ui-card class="ui borderless segment user-info-card rating-container">
                                <div class="flex align-items-center">
                                    <app-avatar
                                        *ngIf="field?.employee"
                                        [employee]="field.employee"
                                        size="icon"
                                    ></app-avatar>
                                    <span class="employeeName"
                                        >{{ field.employee.firstName }} {{ field.employee.lastName }}</span
                                    >
                                </div>
                                <div>
                                    <div
                                        class="ui massive star rating"
                                        [attr.data-rating]="field?.answer"
                                        data-max-rating="10"
                                    ></div>
                                    <div class="rating-labels">
                                        <span>{{ 'performance.templates.lowRating' | translate }}</span>
                                        <span>{{ 'performance.templates.highRating' | translate }}</span>
                                    </div>
                                </div>
                            </ui-card>
                        </ng-template>

                        <ng-template [ngIf]="field.question?.type === 'scale'">
                            <ui-card class="ui borderless segment user-info-card agree-disagree-container">
                                <div class="flex align-items-center">
                                    <app-avatar
                                        *ngIf="field?.employee"
                                        [employee]="field.employee"
                                        size="icon"
                                    ></app-avatar>
                                    <span class="employeeName"
                                        >{{ field.employee.firstName }} {{ field.employee.lastName }}</span
                                    >
                                </div>
                                <div class="agree-disagree-scale">
                                    <span [class.active]="field?.answer === 0">
                                        <mat-icon svgIcon="stronglyDisagree"></mat-icon>
                                        <div
                                            class="label"
                                            [innerHTML]="'performance.templates.stronglyDisagree' | translate"
                                        ></div>
                                    </span>
                                    <span [class.active]="field?.answer === 1">
                                        <mat-icon svgIcon="somewhatDisagree"></mat-icon>
                                        <div [innerHTML]="'performance.templates.somewhatDisagree' | translate"></div>
                                    </span>
                                    <span [class.active]="field?.answer === 2">
                                        <mat-icon svgIcon="neitherAgreeNorDisagree"></mat-icon>
                                        <div
                                            [innerHTML]="'performance.templates.neitherAgreeNorDisagree' | translate"
                                        ></div>
                                    </span>
                                    <span [class.active]="field?.answer === 3">
                                        <mat-icon svgIcon="somewhatAgree"></mat-icon>
                                        <div [innerHTML]="'performance.templates.somewhatAgree' | translate"></div>
                                    </span>
                                    <span [class.active]="field?.answer === 4">
                                        <mat-icon svgIcon="stronglyAgree"></mat-icon>
                                        <div [innerHTML]="'performance.templates.stronglyAgree' | translate"></div>
                                    </span>
                                </div>
                            </ui-card>
                        </ng-template>

                        <ng-template [ngIf]="field.question?.type === 'boolean'">
                            <ui-card class="ui borderless segment user-info-card true-false-container">
                                <div class="flex align-items-center">
                                    <app-avatar
                                        *ngIf="field?.employee"
                                        [employee]="field.employee"
                                        size="icon"
                                    ></app-avatar>
                                    <span class="employeeName"
                                        >{{ field.employee.firstName }} {{ field.employee.lastName }}</span
                                    >
                                </div>
                                <div class="true-false-scale">
                                    <span [class.active]="field.answer == 0">
                                        <mat-icon svgIcon="thumbDown"></mat-icon>
                                        <div class="label">{{ 'performance.templates.noDisagree' | translate }}</div>
                                    </span>
                                    <span [class.active]="field.answer == 1">
                                        <mat-icon svgIcon="thumbUp"></mat-icon>
                                        <div class="label">{{ 'performance.templates.yesAgree' | translate }}</div>
                                    </span>
                                </div>
                            </ui-card>
                        </ng-template>
                    </div>
                </div>

                <div *ngIf="!fields.length" class="emptyLayout">
                    <mat-icon svgIcon="addElement" [matTooltip]="'add' | translate"></mat-icon>
                    <h4 [innerHTML]="'performance.show.emptyReviewResult' | translate"></h4>
                </div>
            </ng-template>

            <ng-template [ngIf]="tab === 'goals'">
                <h3 class="tab-header">
                    {{
                        'performance.show.goalsHeader'
                            | translate
                                : {
                                      reviewStartDate: review.periodStart | appDate: 'mediumDate',
                                      reviewEndDate: review.periodEnd | appDate: 'mediumDate',
                                  }
                    }}
                </h3>

                <div class="goals-info-container padding-top-3">
                    <ng-template ngFor let-goal [ngForOf]="goals">
                        <div class="profile-info-container">
                            <div class="font-medium">{{ goal.title }}</div>
                            <div>
                                {{
                                    'performance.show.dueAt'
                                        | translate: { goalDueAt: goal.dueAt | appDate: 'mediumDate' }
                                }}
                            </div>
                            <div>
                                <ui-badge [type]="goal.dueIn <= 0 ? 'warning' : 'danger'">
                                    <i *ngIf="goal.metricType === 'percent'" class="icon percent"></i>
                                    <i *ngIf="goal.metricType === 'dollar'" class="icon dollar"></i>
                                    <i *ngIf="goal.metricType === 'binary'" class="icon checkmark"></i>
                                    <i *ngIf="goal.metricType === 'number'" class="icon hashtag"></i>
                                    {{
                                        'performance.show.goalsPill'
                                            | translate
                                                : { goalsComplete: goal.currentValue, goalsLength: goal.metricValue }
                                    }}
                                </ui-badge>
                            </div>
                        </div>
                        <div class="goal-completion-container margin-bottom-3">
                            <ui-badge *ngIf="goal.isComplete" type="success">{{
                                'performance.show.complete' | translate
                            }}</ui-badge>
                            <ui-badge *ngIf="!goal.isComplete" type="danger">{{
                                'performance.show.incomplete' | translate
                            }}</ui-badge>
                        </div>
                        <div>
                            <div
                                class="ui progress"
                                [attr.data-value]="goal.currentValue"
                                [attr.data-total]="goal.metricValue"
                            >
                                <div class="bar">
                                    <div class="progress"></div>
                                </div>
                            </div>
                            <div [innerHTML]="goal.description | sanitizeHtml" class="font-medium"></div>
                            <mat-divider class="margin-top-3 margin-bottom-3"></mat-divider>
                        </div>
                    </ng-template>
                </div>
                <p *ngIf="!goals.length">{{ 'performance.show.noActiveGoals' | translate }}</p>
            </ng-template>

            <ng-template [ngIf]="tab === 'feedback-received'">
                <h3 class="tab-header">
                    {{
                        'performance.show.feedbackReceivedHeader'
                            | translate
                                : {
                                      reviewStartDate: review.periodStart | appDate: 'mediumDate',
                                      reviewEndDate: review.periodEnd | appDate: 'mediumDate',
                                  }
                    }}
                </h3>
                <div class="feedback-info">
                    <ng-template ngFor let-comment [ngForOf]="feedbackReceived">
                        <div class="profile-info-container">
                            <div class="flex align-items-center">
                                <app-avatar [employee]="comment.creator" size="icon"></app-avatar>
                                <span class="employeeName"
                                    >{{ comment.creator.firstName }} {{ comment.creator.lastName }}</span
                                >
                            </div>
                            <div class="font-medium">{{ comment.createdAt | appDate: 'mediumDate' }}</div>
                            <div class="font-medium">{{ comment.visibility }}</div>
                            <div>
                                <ui-badge *ngIf="comment.positive" type="success">{{
                                    feedbackTypes.positive | translate
                                }}</ui-badge>
                                <ui-badge *ngIf="comment.constructive" type="warning">{{
                                    feedbackTypes.constructive | translate
                                }}</ui-badge>
                                <ui-badge *ngIf="comment.negative" type="danger">{{
                                    feedbackTypes.negative | translate
                                }}</ui-badge>
                            </div>
                        </div>
                        <div class="font-medium comment-title">{{ comment.title }}</div>
                        <div [innerHTML]="comment?.body | sanitizeHtml" class="comment-body"></div>
                        <mat-divider class="margin-top-3"></mat-divider>
                    </ng-template>
                </div>
                <p *ngIf="!feedbackReceived?.length">{{ 'performance.show.noFeedbackReceived' | translate }}</p>
            </ng-template>

            <ng-template [ngIf]="tab === 'feedback-given'">
                <h3 class="tab-header">
                    {{
                        'performance.show.feedbackGivenHeader'
                            | translate
                                : {
                                      reviewStartDate: review.periodStart | appDate: 'mediumDate',
                                      reviewEndDate: review.periodEnd | appDate: 'mediumDate',
                                  }
                    }}
                </h3>
                <div class="feedback-info">
                    <ng-template ngFor let-comment [ngForOf]="feedbackGiven">
                        <div class="profile-info-container">
                            <div class="flex align-items-center">
                                <app-avatar [employee]="comment.creator" size="icon"></app-avatar>
                                <span class="employeeName"
                                    >{{ comment.creator.firstName }} {{ comment.creator.lastName }}</span
                                >
                            </div>
                            <div class="font-medium">{{ comment.createdAt | appDate: 'mediumDate' }}</div>
                            <div class="font-medium">{{ comment.visibility }}</div>
                            <div>
                                <mat-icon *ngIf="comment.positive" svgIcon="stronglyAgree"></mat-icon>
                                <mat-icon *ngIf="comment.constructive" svgIcon="neitherAgreeNorDisagree"></mat-icon>
                                <mat-icon *ngIf="comment.negative" svgIcon="stronglyDisagree"></mat-icon>
                            </div>
                        </div>
                        <div class="font-medium comment-title">{{ comment.title }}</div>
                        <div [innerHTML]="comment?.body | sanitizeHtml" class="comment-body"></div>
                        <mat-divider class="margin-top-3"></mat-divider>
                    </ng-template>
                </div>
                <p *ngIf="!feedbackGiven?.length">{{ 'performance.show.noFeedbackGiven' | translate }}</p>
            </ng-template>
        </form>
    </div>
</div>
